import TerminalNameWithLocationLink from './TerminalNameWithLocationLink';

export default TerminalNameWithLocationLink;
